const KNOWN_SECTION_TYPES = new Set([
  "pageTitle",
  "summaryStats",
  "actionBar",
  "filterBar",
  "dataTable",
  "analyticsGrid",
  "liveSummaryStats",
  "liveDeviceGrid",
]);

const KNOWN_WIDGET_TYPES = new Set([
  "statCard",
  "actionButton",
  "search",
  "tableFilter",
  "analyticsCard",
  "metricCard",
  "liveFilter",
]);

const requiredString = (value) => typeof value === "string" && value.trim().length > 0;

export function validateModuleLayout(layout) {
  const errors = [];

  if (!layout || typeof layout !== "object") {
    return { valid: false, errors: ["Layout must be an object"] };
  }

  if (typeof layout.schemaVersion !== "number") {
    errors.push("schemaVersion must be a number");
  }

  if (!requiredString(layout.pageId)) {
    errors.push("pageId is required");
  }

  if (!requiredString(layout.module)) {
    errors.push("module is required");
  }

  if (!Array.isArray(layout.sections) || layout.sections.length === 0) {
    errors.push("sections must be a non-empty array");
  } else {
    const hasTable = layout.sections.some((section) => section?.type === "dataTable");

    if (!hasTable) {
      errors.push("sections must include a dataTable section");
    }

    layout.sections.forEach((section, sectionIndex) => {
      if (!requiredString(section?.id)) {
        errors.push(`sections[${sectionIndex}].id is required`);
      }

      if (!requiredString(section?.type)) {
        errors.push(`sections[${sectionIndex}].type is required`);
      } else if (!KNOWN_SECTION_TYPES.has(section.type)) {
        errors.push(`sections[${sectionIndex}] has unknown type "${section.type}"`);
      }

      if (section?.type === "summaryStats") {
        if (!Array.isArray(section.widgets)) {
          errors.push(`sections[${sectionIndex}].widgets must be an array`);
        } else {
          section.widgets.forEach((widget, widgetIndex) => {
            if (requiredString(widget?.type) && !KNOWN_WIDGET_TYPES.has(widget.type)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}] has unknown type "${widget.type}"`,
              );
            }
            if (!requiredString(widget?.metricKey)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}].metricKey is required`,
              );
            }
          });
        }
      }

      if (section?.type === "actionBar" || section?.type === "filterBar") {
        if (!Array.isArray(section.widgets)) {
          errors.push(`sections[${sectionIndex}].widgets must be an array`);
        } else {
          section.widgets.forEach((widget, widgetIndex) => {
            if (requiredString(widget?.type) && !KNOWN_WIDGET_TYPES.has(widget.type)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}] has unknown type "${widget.type}"`,
              );
            }
          });
        }
      }

      if (
        section?.type === "analyticsGrid" ||
        section?.type === "liveSummaryStats" ||
        section?.type === "liveDeviceGrid"
      ) {
        if (!Array.isArray(section.widgets)) {
          errors.push(`sections[${sectionIndex}].widgets must be an array`);
        } else {
          section.widgets.forEach((widget, widgetIndex) => {
            if (requiredString(widget?.type) && !KNOWN_WIDGET_TYPES.has(widget.type)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}] has unknown type "${widget.type}"`,
              );
            }
          });
        }
      }

      if (section?.type === "dataTable") {
        if (!Array.isArray(section.columns) || section.columns.length === 0) {
          errors.push(`sections[${sectionIndex}].columns must be a non-empty array`);
        } else {
          section.columns.forEach((column, columnIndex) => {
            if (!requiredString(column?.fieldKey)) {
              errors.push(
                `sections[${sectionIndex}].columns[${columnIndex}].fieldKey is required`,
              );
            }
            if (!requiredString(column?.labelKey)) {
              errors.push(
                `sections[${sectionIndex}].columns[${columnIndex}].labelKey is required`,
              );
            }
          });
        }
      }
    });
  }

  return { valid: errors.length === 0, errors };
}
